<div class="reward">
  <img class="reward__top_img" src="/images/rewards_top.jpg" alt="img">
  <div class="reward__qrs">
    <img class="reward__qrs__img" src="/images/rewardsQrApp.png" alt="QrAppStore">
    <img class="reward__qrs__img" src="/images/rewardsQrGoogle.png" alt="QrGooglePlay">
  </div>
  <img class="reward__bottom_img" src="/images/rewards_bottom.png" alt="img">
</div>
